export const REDUCE_BROKERCOMPANY_SIGNUP_ELEMENT = 'REDUCE_BROKERCOMPANY_SIGNUP_ELEMENT';
export const CLEAR_BROKERCOMPANY_SIGNUP = 'CLEAR_BROKERCOMPANY_SIGNUP';
export const UPSERT_BROKERCOMPANY_SIGNUP = 'UPSERT_BROKERCOMPANY_SIGNUP';
export const GET_BROKER_COMPANY_SIGNUP_TEMPLATE = 'GET_BROKER_COMPANY_SIGNUP_TEMPLATE';
export const REDUCE_BROKER_COMPANY_SIGNUP_TEMPLATE = 'REDUCE_BROKER_COMPANY_SIGNUP_TEMPLATE';
export const REDUCE_BROKER_COMPANY_SIGNUP_VALIDATION_INFO = 'REDUCE_BROKER_COMPANY_SIGNUP_VALIDATION_INFO';
export const INITIALIZE_CREDIT_CARD = 'INITIALIZE_CREDIT_CARD';
export const CONFIRM_CREDIT_CARD_SETUP = 'CONFIRM_CREDIT_CARD_SETUP';
export const REDUCE_SETUP_INTENT_CLIENT_SECRET = 'REDUCE_SETUP_INTENT_CLIENT_SECRET';
